module.exports = __webpack_public_path__ + "img/widget_0061.615ba08a.png";